import scheduleReducer from './scheduleReducer';
export default scheduleReducer;

